import { render, staticRenderFns } from "./QCMItem.vue?vue&type=template&id=733e2ca3&"
import script from "./QCMItem.vue?vue&type=script&lang=ts&"
export * from "./QCMItem.vue?vue&type=script&lang=ts&"
import style0 from "./QCMItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports